export default __webpack_public_path__ + "static/media/stat-icon.923f7b20.svg";